<ng-container>
  <div class="modal-header">
    <div class="modal-title fw-medium">Provide feedback</div>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      data-testid="modal_close_btn"
      (click)="onCancel()"
    >
    </button>
  </div>
  <div class="modal-body">
    @if (formVisible) {
      <form [formGroup]="form">
        <formly-form [fields]="fields"
          [options]="formOptions"
          [form]="form"
          [model]="model" />
      </form>
    }
  </div>
  <div class="modal-footer">
    <button data-testid="modal_submit_btn" type="submit" class="btn btn-colour-blue-600 fw-bold" (click)="onSubmit()">
      Submit
    </button>
    <button data-testid="modal_cancel_btn" class="btn btn-outline-colour-grayscale-900 fw-bold" (click)="onCancel()">
      Cancel
    </button>
  </div>
</ng-container>

@if (!completed) {
  <lib-loading />
}
